import React, { Component } from "react";
import PropTypes from "prop-types";
import "./styles.css";
import { Link } from "react-router-dom";
import imgLogoLight from "assets/images/logo-light.png";
import imgLogoDark from "assets/images/logo-dark.png";

const defaultOpt = {
  position: "fixed",
  transparent: false,
  animation: false,
  fixedAt: 500,
};

class Header extends Component {
  static propTypes = {
    position: PropTypes.oneOf(["absolute", "fixed", "sticky"]),
    transparent: PropTypes.bool,
    animation: PropTypes.bool,
    fixedAt: PropTypes.number,
  };

  constructor(props) {
    super(props);

    this.opt = { ...defaultOpt, ...props };
    this.state = { open: false };

    this.navItems = [
      { label: "Single" },
      { label: "Dropdown" },
      { label: "Multi Column" },
    ];

    if (this.props.position === "sticky") {
      this.opt.position = "absolute";
    }

    this.timestamp = Date.now();
  }

  componentDidMount = () => {
    if (this.nav && this.props.position === "sticky") {
      this.nav.classList.remove("no-animation");
      this.isFixed = this.nav.classList.contains("nav--fixed");
      this.addStickyListener(this.opt.fixedAt);
    }
  };

  componentWillUnmount = () => {
    if (this.nav) {
      this.removeStickyListener();
    }
  };

  addStickyListener = (fixedAt) => {
    document.addEventListener("scroll", this.onScroll, false);
  };

  removeStickyListener = () => {
    document.removeEventListener("scroll", this.onScroll, false);
  };

  onScroll = () => {
    const now = Date.now();

    if (now - this.timestamp >= 10) {
      window.requestAnimationFrame(this.toggleNav);
      this.timestamp = now;
    }
  };

  toggleNav = () => {
    const y = window.pageYOffset;
    const passedFixedAt = Math.abs(y) > this.opt.fixedAt;

    if (passedFixedAt && !this.isFixed) {
      this.isFixed = true;
      this.nav.classList.add("nav--fixed");
    }

    if (!passedFixedAt && this.isFixed) {
      this.isFixed = false;
      this.nav.classList.remove("nav--fixed");
    }
  };

  render = () => {
    let navbarClass = `nav-bar nav--${this.opt.position}`;

    if (this.opt.transparent) {
      navbarClass += " nav--transparent";
    }

    if (!this.opt.animation) {
      navbarClass += " no-animation";
    }

    return (
      <div>
        <nav>
          <div
            className={navbarClass}
            ref={(el) => {
              this.nav = el;
            }}
          >
            <div className="nav-module logo-module left">
              <a href="http://vic-apply.com.tw">
                <img alt="logo" className="logo logo-dark" src={imgLogoDark} />
                <img
                  alt="logo"
                  className="logo logo-light"
                  src={imgLogoLight}
                />
              </a>
            </div>
            {this.renderMenu()}
          </div>
          <div
            className="nav-mobile-toggle visible-sm visible-xs"
            onClick={() => {
              this.setState({ open: !this.state.open });
            }}
          >
            <i className="icon-Align-JustifyAll icon icon--sm"></i>
          </div>
        </nav>
        <div
          className="nav-sidebar"
          style={{ display: this.state.open ? "block" : "none" }}
        >
          {this.renderSidebar()}
        </div>
      </div>
    );
  };

  renderMenu = () => (
    <div className="nav-module menu-module left">
      <ul className="menu">
        <li className="dropdown">
          <a role="button">品牌與產品</a>
          <ul>
            <li>
              <Link to={"/asko/products"}>Asko 瑞典雅士高</Link>
            </li>
            <li>
              <a href="https://dalli.com.tw">Dalli 德國達麗</a>
            </li>
            <li>
              <a href="http://clorox.com.tw">Clorox 高樂氏</a>
            </li>
            {/* <li>
              <Link to={'/morphyrichards/products'}>Morphy Richards 精品家電</Link>
            </li> */}
            {/* <li>
              <Link to={"/microdry/products"}>Microdry 紐約設計</Link>
            </li> */}
          </ul>
        </li>
        <li className="dropdown">
          <a href="http://vic-apply.com.tw/stores">購買據點</a>
        </li>
      </ul>
    </div>
  );

  renderSidebar = () => (
    <div className="nav-sidebar-content">
      <div className="toolbar">
        <button type="button" onClick={() => this.setState({ open: false })}>
          x
        </button>
      </div>
      <ul
        onClick={() => {
          this.setState({ open: false });
        }}
      >
        <li>
          品牌與產品
          <ul>
            <li>
              <a href="https://asko.vic-apply.com.tw">Asko 瑞典雅士高</a>
            </li>
            <li>
              <a href="https://dalli.com.tw">Dalli 德國達麗</a>
            </li>
            <li>
              <a href="http://clorox.com.tw">Clorox 高樂氏</a>
            </li>
            <li>
              <a href="https://microdry.com.tw">Microdry 紐約設計</a>
            </li>
          </ul>
        </li>
        <li>
          <a href="http://vic-apply.com.tw/stores">購買據點</a>
        </li>
      </ul>
    </div>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js